import { useEffect, useState } from "react";

/**
 * Returns `true` once the browser hits an idle window (or after `timeoutMs`
 * as a fallback for browsers without `requestIdleCallback`). Use it to delay
 * mounting non-critical UI until after LCP.
 */
export const useIdleReady = (timeoutMs = 2000): boolean => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const w = window as Window & {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
      cancelIdleCallback?: (id: number) => void;
    };

    if (typeof w.requestIdleCallback === "function") {
      const id = w.requestIdleCallback(() => setReady(true), { timeout: timeoutMs });
      return () => w.cancelIdleCallback?.(id);
    }

    const t = setTimeout(() => setReady(true), Math.min(timeoutMs, 1500));
    return () => clearTimeout(t);
  }, [timeoutMs]);

  return ready;
};
